import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { kioskLoginActions } from "../_store";
import { getStoredValue, removeStoredValue } from "../../src/_helpers/storageHelper";
import PreventBackNavigation from "./PreventBackNavigation";

const PublicRoute = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const maintenanceData = useSelector((state) => state?.kioskLogin?.applicationSettingsData);

  const loginInterval = parseInt(process.env.REACT_APP_LOGIN_INTERVAL) || 120000;
  //const loginInterval = 120000; //2 min 

  useEffect(() => {
    /** ========== LOGIN INTERVAL ========== */
    const intervalId = setInterval(() => {
      handleautoLogin();
    }, loginInterval);

    return () => clearInterval(intervalId);
  }, []);


  const handleautoLogin = async () => {
    const storedLoginDetails = getStoredValue("loginDetails");
    const loginResponse = getStoredValue("loginResponse");

    if (loginResponse != null) return; // Stop setting up interval if already logged in
    if (storedLoginDetails?.FacilityID && storedLoginDetails?.KiosksCode) {
      const loginPayload = {
        InmateResidentId: '00', UserPassword: '00', facilityID: storedLoginDetails.FacilityID,
        kiosksCode: storedLoginDetails.KiosksCode, IsApplogin: 0
      };
      dispatch(kioskLoginActions.getInmateLoginValidate(loginPayload));
    }
  }


  // Function to handle user interaction and check for maintenance mode
  const handleUserAction = () => {
    dispatch(kioskLoginActions.MaintenanceMode("WEB"))
      .then((result) => {
        const data = result?.payload;
        if (
          Object?.keys(data || {}).length === 0 ||
          data?.IsApplicationMaintenance === 0
        ) {
          return; // Do nothing if no maintenance
        }

        // Clear localStorage and redirect to maintenance page
        removeStoredValue("loginResponse"); removeStoredValue("lang");
        navigate("/maintenance");
      })
      .catch((err) => {
        console.error("Failed to fetch maintenance data", err);
      });
  };

  // Attach event listeners for user interaction
  useEffect(() => {
    const events = ["click", "keydown"];
    events.forEach((event) =>
      window.addEventListener(event, handleUserAction)
    );
    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserAction)
      );
    };
  }, [maintenanceData]);

  // Initial maintenance check
  useEffect(() => {
    handleUserAction();
  }, []);

  return <> <PreventBackNavigation />{children}
  </>;
};

export default PublicRoute;
